import { Link } from "react-router-dom";
import { useState } from "react";
import ThemeToggle from "./ThemeToggle";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-white/80 dark:bg-[#0a0a0a]/80 backdrop-blur-md border-b border-[#0077cc] px-6 py-4 flex justify-between items-center fixed top-0 left-0 right-0 z-50 shadow-md transition-all duration-300">
      
      {/* Logo and Title */}
      <Link to="/" className="flex items-center space-x-3">
        <img src="/logo.png" alt="Project Port Logo" className="h-10 w-10 object-contain" />
        <span className="text-[#0077cc] text-2xl font-bold tracking-wide">Project Port</span>
      </Link>

      {/* Theme Toggle */}
      <ThemeToggle />

      {/* Desktop Links */}
      <div className="space-x-4 hidden md:flex">
        <Link to="/templates" className="text-black dark:text-white hover:text-[#0077cc] transition">
          Templates
        </Link>
        <Link to="/pricing" className="text-black dark:text-white hover:text-[#0077cc] transition">
          Pricing
        </Link>
        <Link to="/about" className="text-black dark:text-white hover:text-[#0077cc]" onClick={() => setMenuOpen(false)}>
            About
          </Link>
        <Link to="/get-started">
          <button className="bg-[#0077cc] text-white px-4 py-2 rounded-full hover:bg-[#005fa3] transition">
            Get Started
          </button>
        </Link>
      </div>

      {/* Mobile Menu Toggle */}
      <button
        className="md:hidden text-black dark:text-white focus:outline-none"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          {menuOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="absolute top-16 left-0 w-full bg-white/90 dark:bg-[#0a0a0a]/95 backdrop-blur-md px-6 py-4 flex flex-col space-y-4 md:hidden border-t border-[#0077cc] shadow-lg transition-all duration-300">
          <Link to="/templates" className="text-black dark:text-white hover:text-[#0077cc]" onClick={() => setMenuOpen(false)}>
            Templates
          </Link>
          <Link to="/about" className="text-black dark:text-white hover:text-[#0077cc]" onClick={() => setMenuOpen(false)}>
            About
          </Link>
          <Link to="/pricing" className="text-black dark:text-white hover:text-[#0077cc]" onClick={() => setMenuOpen(false)}>
            Pricing
          </Link>
          <Link to="/get-started" onClick={() => setMenuOpen(false)}>
            <button className="w-full bg-[#0077cc] text-white px-4 py-2 rounded-full hover:bg-[#005fa3] transition">
              Get Started
            </button>
          </Link>
        </div>
      )}
    </nav>
  );
}
